import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./SabadKharidDrawer.css";
import Counter2 from "./../counter/Counter2";
import { useContext } from "react";
import SimpleContext from "./../../context/SimpleContext";
import config from "./../../../services/config.json";
import NumberFormat from "react-number-format";
import { useState } from "react";
import { useHistory } from "react-router-dom";

const SabadKharidDrawer = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  const [DialogSabtInSabad, setDialogSabtInSabad] = useState(false);

  let Product_Drawer = "SabadDrawerMain";

  if (context.ProductDrawer) {
    Product_Drawer = "SabadDrawerMain open";
  }

  const SabtInSabad = () => {
    context.handleHistoryPush("/Buy");
  };

  return (
    <div className="SabadDrawerMain">
      <div className="DrawerPagesHeader" onClick={context.handleProductDrawer}>
        <i className="fa fa-chevron-up" style={{ fontSize: "12px" }} />
        <p style={{ fontSize: "13px", margin: "0", fontWeight: "bold" }}>
          سبد خرید
        </p>
      </div>
      <div className="SabadDrawerTitleBox">
        {context.CartItems.length > 0 ? (
          context.CartItems.map((item, i) => (
            <div className="SabadKalaContainer" key={i}>
              <div className="SabadImgPlace">
                <img
                  src={`${config.AndroidProductsPictures}/${item.slug}.jpg`}
                  style={{ width: "100%", maxWidth: "120px" }}
                />
              </div>
              <div className="SabadTextPlace">
                <div className="textP">
                  <p>{item.name}</p>
                  <p>
                    قیمت بدون تخفیفات و جوایز
                    <NumberFormat
                      value={item.price * item.numUnit}
                      displayType={"text"}
                      thousandSeparator={true}
                    />{" "}
                    ريال
                    <br />
                    <br />
                  </p>
                </div>
                <div className="counterp">
                  <Counter2
                    ProCount={item.ProCount}
                    min={item.min}
                    max={item.max}
                    unit={item.unit}
                    numUnit={item.numUnit}
                    price={item.price}
                    slug={item.slug}
                    name={item.name}
                    stock={item.stock}
                    numSale={item.numSale}
                    goodsRef={item.goodsRef}
                    uniqueid={item.uniqueid}
                  />
                </div>
              </div>
              <div
                className="SabadDeleteBtn"
                onClick={() => context.handleDeleteItemFromSabad(item.slug)}
              >
                <i className="fa fa-times-circle" />
              </div>
            </div>
          ))
        ) : (
          <h6 style={{ color: "gray", marginTop: "76%" }}>
            کالایی به سبد خرید اضافه نکرده اید
          </h6>
        )}
      </div>
      <div className="pagination">
        <Button
          className="KharidButton"
          onClick={() => setDialogSabtInSabad(true)}
        >
          ثبت سفارش
        </Button>
      </div>

      <Modal show={DialogSabtInSabad} centered>
        <Modal.Body
          style={{ width: "100%", color: "black" }}
          className="text-center p-3"
        >
          <p style={{ margin: "0", fontSize: "17px", textAlign: "center" }}>
            آیا از ثبت محصولات انتخاب شده در سبد خرید خود مطمئن هستید؟
          </p>
        </Modal.Body>

        <Modal.Footer
          style={{
            padding: "3%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Button
            variant="success"
            style={{ width: "45%" }}
            onClick={() => SabtInSabad()}
          >
            بله
          </Button>
          <Button
            variant="danger"
            style={{ width: "45%" }}
            onClick={() => setDialogSabtInSabad(false)}
          >
            خیر
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SabadKharidDrawer;
